import { useEffect, useRef } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import useAppContext from "./hooks/useAppHook";
import { safeGetItem, safeSetItem } from "./utils/safeStorage";

export default function AuthenticatedRoute({ children }) {
    const location = useLocation();
    const {pathname, search} = location ?? {pathname: "", search: ""}; // Avoid potential null pointer exception
    const [searchParams] = useSearchParams();
    const tokenFromUrl = searchParams?.get("token");
    const { token, setParkedURL } = useAppContext() ?? {}; // Avoid potential null pointer exception
    const authRef = useRef(token ?? safeGetItem("token"));

    useEffect(() => {
        if (tokenFromUrl) {
            safeSetItem("token", tokenFromUrl);
            authRef.current = tokenFromUrl; // Update the ref's current value
        }

        if (authRef.current) {
            setParkedURL?.(`${pathname}${search}`);
        }
    }, [tokenFromUrl, token, pathname, search]);

    // If not authenticated, redirect to the login page with a redirect URL
    if (!authRef.current) {
        const redirectUrl = `/#/login?redirect=${encodeURIComponent(pathname + search)}`;
        window.location.href = redirectUrl;
        return null;
    }

    // If authenticated, render the children components
    return children ? children : null; // Avoid potential null pointer exception
}
